<template>
  <div class="placement-test-graded">
    <div class="scores">
      <DonutChart :percent="testResults.score" />
      <div style="margin-left: 20px;">
        <h3>{{ $t("results") }}</h3>
        <h4>
          {{ testResults.correct }} /
          {{ testResults.mistake + testResults.correct }}
        </h4>
      </div>
      <!-- <span class="grading" v-if="getGrade()">
        {{ $t("test grade", { grade: `${getGrade()}` }) }}
      </span> -->
    </div>
    <div class="btn" style="color:white" @click="$emit('handleDoneTest')">
      {{ $t("done") }}
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DonutChart from "@/components/chart/DonutChart";
export default {
  name: "PlacementTestGrading",
  components: { DonutChart },
  // methods: {
  //   getGrade() {
  //     if (this.testResults) {
  //       let percent = this.testResults.score;
  //       if (percent >= 90) return "A";
  //       if (percent >= 80) return "B";
  //       if (percent >= 70) return "C";
  //       if (percent >= 60) return "D";
  //       return null;
  //     }

  //     return null;
  //   }
  // },
  computed: {
    ...mapState("placementTest", ["placementTest", "testResults"])
  }
};
</script>

<style lang="scss">
.placement-test-graded {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .scores {
    display: flex;
    text-align: left;
    align-items: center;
    .grading {
      color: green;
      font-size: 1.2rem;
      font-weight: bold;
      padding-left: 8px;
    }
  }
}
</style>
